import type { OrderControlPieceKey, OrderSurfacePresentation } from '@hopdrive/feature-order-index';

import type { DashboardKnobs } from '@utils/embedSettings';

/** The Orders tab's view controls, the ones the dashboard toolbar held; `showToolbar` governs them. */
export const ORDERS_TOOLBAR_CONTROLS = ['viewMode', 'sort', 'groupBy', 'displayPreferences'] as const satisfies readonly OrderControlPieceKey[];

/** Every filter control on the Orders tab; `showFilters` governs them. The active chips stay, so
 * a filter the viewer saved earlier still shows and can be cleared with the filters hidden. */
export const ORDERS_FILTER_CONTROLS = [
  'search',
  'dateRange',
  'createdBy',
  'market',
  'product',
  'driver',
  'provider',
] as const satisfies readonly OrderControlPieceKey[];

/**
 * The Orders tab's presentation from the integrator's dashboard knobs: `showToolbar`, `showFilters`,
 * and `showMetrics` remove the view controls, the filters, and the metric tiles; `compactMode`
 * folds the controls and the tiles into collapsed accordions. Refresh and the integrator CSV
 * columns, both part of the integrator contract, are always on.
 */
export function resolveOrdersPresentation({ showToolbar, showFilters, showMetrics, compactMode }: DashboardKnobs): OrderSurfacePresentation {
  const disable: OrderControlPieceKey[] = [
    ...(showToolbar ? [] : ORDERS_TOOLBAR_CONTROLS),
    ...(showFilters ? [] : ORDERS_FILTER_CONTROLS),
    ...(showMetrics ? [] : (['metricTiles'] as const)),
  ];
  return {
    controls: { disable },
    collapsibleControls: compactMode,
    refresh: true,
    integratorExport: true,
  };
}
